<template>
      <search-panel mode="ver">
        <a-row slot="search">
          <a-col>
            <a-input-search
              type='textarea'
              style="padding: 6px;"
              placeholder="请输入要查询的内容"
              rows="3"
              v-model="tp_keywords"
              @change="inputChange"
              id="content"/>
          </a-col>
          <a-col>
            <a>
              <a-icon type="search" style="font-size: 20px; position: absolute; top: 28px; right: 2px; z-index: 1;" @click="searchNews()"></a-icon>
            </a>
          </a-col>
        </a-row>
      </search-panel>
</template>

<script>

import {SearchPanel} from '@/com/Basic'

export default {
  name: 'AdsSearchPanel',
  data() {
    return {
      tp_keywords: this.keywords,
      advertList: []
    }
  },
  props: {
    postdata: {},
    keywords: {}
  },
  components: {
    SearchPanel
  },
  watch: {
    tp_keywords(newvalue, oldvalue) {
      this.tp_keywords = newvalue
    },

    postdata(newvalue, oldvalue) {
      this.tp_keywords = newvalue.content
    }
  },
  methods: {
    inputChange: function() {
      this.$emit('inputchange', this.tp_keywords);
    },
    searchNews: function() {
      let page = 1;
      this.postdata["page"] = page
      this.postdata["from"] = (page - 1) * 20
      this.postdata["to"] = page * 20
      if (this.tp_keywords != "") {
        this.postdata["content"] = this.tp_keywords
      } 
      else {
        delete this.postdata["keywords"]
      }
      this.postdata["task"] = "NEWS_SEARCH"
      this.postdata["api-path"] = "news"
      let that = this
      let loading = that.$message.loading("搜索中...", 0);
      that.post('news', that.postdata)
        .then(function(data) {
          setTimeout(loading, 0);
          that.$store.commit('updatepostdata', that.postdata, 'advert');
          that.$store.commit('updateresult', data.data, 'advert');
          that.$store.commit('updaterelationitem', {});

          that.$emit('search', that.postdata, data.data, {});
        }).catch(function (e) {
          setTimeout(loading, 0);
          that.$message.error("查询失败")
      })
    }
  },
  created() {
  }
}
</script>

<style scoped>
  .pb8 {
    padding-bottom: 8px;
  }
</style>
